import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentHouseMediaSnapshot from './content-house-media-snapshot-model'
import {
  delete_contentHouseMediaSnapshot,
  load_contentHouseMediaSnapshots,
  store_contentHouseMediaSnapshot,
} from './contentHouseMediaSnapshot-service'

export const LoadContentHouseMediaSnapshotsAsync = createAsyncThunk<any, any>(
  'composer/load/contentHouseMediaSnapshot',
  async (params: { uid: string }) => {
    return await load_contentHouseMediaSnapshots(params)
  },
)

export const CreateContentHouseMediaSnapshotAsync = createAsyncThunk<any, any>(
  'composer/create/contentHouseMediaSnapshot',
  async (params: ContentHouseMediaSnapshot) => {
    return await store_contentHouseMediaSnapshot(params)
  },
)

export const DeleteContentHouseMediaSnapshotAsync = createAsyncThunk<any, any>(
  'composer/delete/contentHouseMediaSnapshot',
  async (params) => {
    return await delete_contentHouseMediaSnapshot(params)
  },
)
